function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTag = function SvgIconTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.746 1.147a3.91 3.91 0 0 0-1.262-.849A3.818 3.818 0 0 0 17.992 0H3.947c-1.101 0-2.035.382-2.8 1.147C.382 1.912 0 2.83 0 3.901v14.045c0 .551.107 1.064.321 1.538.214.474.49.88.826 1.216l15.698 15.697a4.07 4.07 0 0 0 1.216.827c.474.214.987.321 1.538.321.55 0 1.063-.107 1.537-.321.475-.215.88-.49 1.217-.827l14.044-14.044c.368-.368.651-.788.85-1.263.198-.474.298-.986.298-1.537 0-.52-.1-1.025-.298-1.515a3.373 3.373 0 0 0-.85-1.239L20.746 1.147ZM9.822 13.678c-1.101 0-2.035-.383-2.8-1.148-.765-.765-1.147-1.683-1.147-2.754 0-1.101.382-2.034 1.147-2.799.765-.765 1.699-1.148 2.8-1.148 1.071 0 1.989.383 2.754 1.148.765.765 1.148 1.698 1.148 2.799 0 1.071-.383 1.989-1.148 2.754-.765.765-1.683 1.148-2.754 1.148Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "matrix(.53964 0 0 .53964 .85 0)"
  }));
};
export default SvgIconTag;